var map = {
	"./auth/controllers/auth-form/auth-form.html": 78534,
	"./auth/views/account-update-dialog.tpl.html": 12925,
	"./auth/views/auth-verification-dialog.tpl.html": 70758,
	"./auth/views/profile-dialog.tpl.html": 21250,
	"./auth/views/service-dialog.tpl.html": 99559,
	"./auth/views/service-form.tpl.html": 30215,
	"./auth/views/staff-dialog.tpl.html": 76847,
	"./auth/views/tokens-dialog.tpl.html": 17340,
	"./billing/dialogs/care-plan-search/care-plan-search-dialog.tpl.html": 99445,
	"./billing/dialogs/invoice-beneficiary-choice/invoice-beneficiary-choice.tpl.html": 73119,
	"./billing/views/billing-credit-note-list.html": 58357,
	"./billing/views/billing-main.html": 17604,
	"./billing/views/billing-workflow.html": 20556,
	"./billing/views/contract-details.html": 47958,
	"./billing/views/contract-form.html": 73995,
	"./billing/views/contract-guest-edit-dialog.html": 22807,
	"./billing/views/contract-historic.tpl.html": 38436,
	"./billing/views/contract-list.html": 41090,
	"./billing/views/contract-multirenew-confirm-dialog.html": 62253,
	"./billing/views/contract-plan.tpl.html": 14664,
	"./billing/views/contract-pointing-historic-dialog.html": 30575,
	"./billing/views/contract-renew.tpl.html": 9753,
	"./billing/views/contract-terminate-dialog.tpl.html": 71427,
	"./billing/views/credit-note-form-bottom.html": 39321,
	"./billing/views/credit-note-form.html": 12676,
	"./billing/views/dental-treatment-plan-search.tpl.html": 31675,
	"./billing/views/expense-form-bottom.html": 49887,
	"./billing/views/expense-form-header.html": 31178,
	"./billing/views/expense-form.html": 31323,
	"./billing/views/expense-list.html": 35755,
	"./billing/views/invoice-form-bottom.html": 34855,
	"./billing/views/invoice-form-header.html": 80224,
	"./billing/views/invoice-form.html": 39882,
	"./billing/views/invoice-list.html": 52107,
	"./billing/views/patient-relations.tpl.html": 99672,
	"./billing/views/pec-answer-dialog.tpl.html": 99799,
	"./billing/views/pec-answers.html": 1853,
	"./billing/views/pec-form-bottom.html": 37644,
	"./billing/views/pec-form-header.html": 39023,
	"./billing/views/pec-form.html": 16017,
	"./billing/views/pec-lines.html": 7945,
	"./billing/views/pec-list.html": 83127,
	"./billing/views/procedure-search-modal.tpl.html": 55812,
	"./billing/views/quotation-form-bottom.html": 59862,
	"./billing/views/quotation-form-header.html": 90818,
	"./billing/views/quotation-form.html": 95237,
	"./billing/views/quotation-list.html": 36211,
	"./billing/views/visit-search-modal.tpl.html": 29212,
	"./cam/views/brand-dialog.html": 18153,
	"./cam/views/cam-config-container.html": 42995,
	"./cam/views/cam-config-item-list.html": 74731,
	"./cam/views/cam-config.html": 37575,
	"./cam/views/cam-default-config.html": 93467,
	"./cam/views/cam-document-list-dialog.html": 12159,
	"./cam/views/cam.html": 66060,
	"./cam/views/category-edit-dialog.html": 60300,
	"./cam/views/distributor-dialog.html": 36175,
	"./cam/views/equipment-exploitation-dialog.html": 2507,
	"./cam/views/equipment-exploitations.html": 60853,
	"./cam/views/equipment-form.html": 3951,
	"./cam/views/equipment-owner-dialog.html": 88545,
	"./cam/views/equipment-owner-manager-dialog.html": 44198,
	"./cam/views/equipment-site-edit-dialog.html": 3980,
	"./cam/views/equipment-spare-parts.html": 28043,
	"./cam/views/equipment.html": 17757,
	"./cam/views/generator-edit-dialog.html": 71774,
	"./cam/views/intervention-form.html": 15776,
	"./cam/views/intervention-general-content.html": 9363,
	"./cam/views/intervention-planning-dialog.html": 64789,
	"./cam/views/intervention-step-edit-dialog.html": 32465,
	"./cam/views/intervention-steps.html": 71589,
	"./cam/views/intervention.html": 12294,
	"./cam/views/maintainer-dialog.html": 33193,
	"./cam/views/maintenance-group-dialog.html": 89818,
	"./cam/views/manufacturer-dialog.html": 42073,
	"./cam/views/spare-part-dialog.html": 53688,
	"./care-sheet/views/care-sheet-container.html": 81971,
	"./care-sheet/views/care-sheet-form-bottom.html": 60085,
	"./care-sheet/views/care-sheet-form-header.html": 46822,
	"./care-sheet/views/care-sheet-form.html": 63924,
	"./care-sheet/views/care-sheet-main.html": 72431,
	"./care-sheet/views/dental-base-quotation-search-modal.tpl.html": 26988,
	"./care-sheet/views/dental-consultation-search-modal.tpl.html": 79685,
	"./care-sheet/views/print-sheet.tpl.html": 44895,
	"./certificate/views/category.tpl.html": 93065,
	"./certificate/views/certificate-container.html": 25715,
	"./certificate/views/certificate-form.html": 82072,
	"./certificate/views/certificate-item.tpl.html": 88056,
	"./certificate/views/certificate-list.html": 53980,
	"./certificate/views/certificate-view.html": 22934,
	"./consultation/components/consultation-body/consultation-body.tpl.html": 92432,
	"./consultation/controllers/consultation-body/consultation-body.html": 4065,
	"./consultation/controllers/consultation-container/consultation-container.html": 84856,
	"./consultation/controllers/mobile-consultation/mobile-consultation.html": 9332,
	"./consultation/controllers/observation/observation.html": 7506,
	"./dental-consultation/svg/dental-12-years-compiled.svg": 2517,
	"./dental-consultation/svg/dental-12-years.svg": 23409,
	"./dental-consultation/svg/dental-13-and-half-compiled.svg": 53959,
	"./dental-consultation/svg/dental-13-and-half.svg": 54866,
	"./dental-consultation/svg/dental-6-years-compiled.svg": 13100,
	"./dental-consultation/svg/dental-6-years.svg": 25974,
	"./dental-consultation/svg/dental-7-and-half-compiled.svg": 7861,
	"./dental-consultation/svg/dental-7-and-half.svg": 12497,
	"./dental-consultation/svg/dental-adult-compiled.svg": 27159,
	"./dental-consultation/svg/dental-adult.svg": 2537,
	"./dental-consultation/svg/dental-child-compiled.svg": 99595,
	"./dental-consultation/svg/dental-child.svg": 41426,
	"./dental-consultation/svg/incisor-compiled.svg": 9866,
	"./dental-consultation/svg/incisor.svg": 83907,
	"./dental-consultation/svg/molar-compiled.svg": 27865,
	"./dental-consultation/svg/molar.svg": 94073,
	"./dental-consultation/svg/perio-buccal-bottom-left.svg": 17717,
	"./dental-consultation/svg/perio-buccal-bottom-right.svg": 47876,
	"./dental-consultation/svg/perio-buccal-left.svg": 81385,
	"./dental-consultation/svg/perio-buccal-right.svg": 30146,
	"./dental-consultation/svg/perio-lingual-bottom-left.svg": 86135,
	"./dental-consultation/svg/perio-lingual-bottom-right.svg": 31632,
	"./dental-consultation/svg/perio-lingual-left.svg": 69558,
	"./dental-consultation/svg/perio-lingual-right.svg": 20837,
	"./dental-consultation/views/dental-chart.tpl.html": 99536,
	"./dental-consultation/views/dental-container.html": 73728,
	"./dental-consultation/views/dental-current-consultation-table.tpl.html": 96820,
	"./dental-consultation/views/dental-current-status-table.tpl.html": 97887,
	"./dental-consultation/views/dental-current-view-visit-table.tpl.html": 87807,
	"./dental-consultation/views/dental-initial-status-table.tpl.html": 34536,
	"./dental-consultation/views/dental-plan-stock-dialog.tpl.html": 88159,
	"./dental-consultation/views/dental-procedure-chart.tpl.html": 6901,
	"./dental-consultation/views/dental-procedure-dialog.tpl.html": 76110,
	"./dental-consultation/views/dental-procedure-group-dialog.tpl.html": 11223,
	"./dental-consultation/views/dental-quotation-detail-table.tpl.html": 45443,
	"./dental-consultation/views/dental-quotation-dialog.tpl.html": 70435,
	"./dental-consultation/views/dental-quotation-table.tpl.html": 53490,
	"./dental-consultation/views/dental-treatment-plan-detail-table.tpl.html": 56885,
	"./dental-consultation/views/dental-treatment-plan-table.tpl.html": 83286,
	"./dental-consultation/views/patient-dental-container.html": 89265,
	"./dental-consultation/views/patient-panoramics.tpl.html": 22741,
	"./dental-consultation/views/periodontal-chart.tpl.html": 26116,
	"./dental-consultation/views/periodontal-container.html": 14455,
	"./dental-consultation/views/periodontal-detail.html": 63891,
	"./dental-consultation/views/plan-procedure-steps-dialog.tpl.html": 75254,
	"./dental-consultation/views/teeth-procedures.tpl.html": 56355,
	"./dental-consultation/views/tooth-action-menu.tpl.html": 56407,
	"./dental-consultation/views/tooth-historic-dialog.tpl.html": 21996,
	"./dental-consultation/views/tooth-surface-dialog.tpl.html": 2559,
	"./dental-consultation/views/treatment-plan-dialog.tpl.html": 80117,
	"./exam/components/exam-links/exam-links.tpl.html": 14598,
	"./exam/controllers/exam-container/exam-container.html": 2673,
	"./exam/controllers/exam-form/exam-form.html": 27138,
	"./exam/controllers/exam-list/exam-list.html": 58305,
	"./exam/controllers/exam-model-form/exam-model-form.html": 40623,
	"./exam/controllers/exam-view/exam-view.html": 68355,
	"./exam/controllers/reports-main/reports-main.html": 28095,
	"./exam/dialogs/move-model-dialog/move-model-dialog.tpl.html": 48467,
	"./example-module/views/example.html": 54789,
	"./forms/controllers/form-detail/form-detail.html": 89245,
	"./forms/controllers/forms-container/forms-container.html": 18270,
	"./forms/controllers/general-forms-container/general-forms-container.html": 36245,
	"./forms/controllers/general-forms-detail/general-forms-detail.html": 14094,
	"./forms/views/form-block.tpl.html": 12096,
	"./forms/views/form-links.tpl.html": 6413,
	"./forms/views/form-template.tpl.html": 38799,
	"./forms/views/load-measurement-button.html": 3500,
	"./frontdesk/views/agenda-dialog.tpl.html": 27488,
	"./frontdesk/views/agenda-form-dialog.tpl.html": 49587,
	"./frontdesk/views/agenda.html": 87835,
	"./frontdesk/views/alert-form-dialog.tpl.html": 30006,
	"./frontdesk/views/appointement-availability-dialog.tpl.html": 96773,
	"./frontdesk/views/appointment-dialog.tpl.html": 58904,
	"./frontdesk/views/appointment-resume.tpl.html": 32235,
	"./frontdesk/views/appointment-search.tpl.html": 70659,
	"./frontdesk/views/backgroun-event-dialog.tpl.html": 88070,
	"./frontdesk/views/calendar-duration-dialog.tpl.html": 62650,
	"./frontdesk/views/entry-dialog.tpl.html": 53309,
	"./frontdesk/views/entry-resume-dialog.tpl.html": 35217,
	"./frontdesk/views/entry-room-update-dialog.tpl.html": 48738,
	"./frontdesk/views/f-ev-menu.tpl.html": 58815,
	"./frontdesk/views/f-ex-menu.tpl.html": 24946,
	"./frontdesk/views/f-rdv-menu.tpl.html": 40905,
	"./frontdesk/views/f-sv-menu.tpl.html": 47574,
	"./frontdesk/views/f-wr-menu.tpl.html": 39119,
	"./frontdesk/views/front-desk-agenda-loader.html": 84191,
	"./frontdesk/views/frontdesk.html": 71800,
	"./frontdesk/views/group-appointment-dialog.tpl.html": 64952,
	"./frontdesk/views/group-appointment-entry-dialog.tpl.html": 46808,
	"./frontdesk/views/last-medical-prescription.tpl.html": 82500,
	"./frontdesk/views/patient-alert.tpl.html": 8562,
	"./frontdesk/views/patient-contract-resume.tpl.html": 32992,
	"./frontdesk/views/patient-resume.tpl.html": 21790,
	"./frontdesk/views/planning-container.html": 20749,
	"./frontdesk/views/planning-details.html": 77286,
	"./frontdesk/views/planning-dialog.tpl.html": 86296,
	"./frontdesk/views/planning-list.html": 20580,
	"./frontdesk/views/planning-visit-container.html": 3749,
	"./frontdesk/views/practice.html": 86698,
	"./frontdesk/views/reason-dialog.tpl.html": 1153,
	"./frontdesk/views/room-dialog.tpl.html": 6209,
	"./frontdesk/views/s-sv-menu.tpl.html": 54567,
	"./frontdesk/views/summary-resume.tpl.html": 65706,
	"./general-payment/views/payment-calculate-dialog.tpl.html": 48537,
	"./general-payment/views/payment-form-body.tpl.html": 39054,
	"./general-payment/views/payment-form-header.tpl.html": 98714,
	"./general-payment/views/payment-form.html": 51937,
	"./general-payment/views/payment-list.html": 1886,
	"./general-payment/views/payment.html": 68907,
	"./generic-states/components/pivot-table/pivot-table.tpl.html": 5012,
	"./generic-states/controllers/activities/activities.html": 47680,
	"./generic-states/controllers/appointment-report/appointment-report.html": 65047,
	"./generic-states/controllers/check-checks/check-checks.html": 29779,
	"./generic-states/controllers/due-dates-report/due-dates-report.html": 52167,
	"./generic-states/controllers/external-treating-physician-activity/external-treating-physician-activity.html": 71240,
	"./generic-states/controllers/generic-states/basic-template.html": 57869,
	"./generic-states/controllers/generic-states/generic-states.html": 4052,
	"./generic-states/controllers/insured-report/insured-report.html": 67798,
	"./generic-states/controllers/medicine-report/medicine-report.html": 20098,
	"./generic-states/controllers/patient-affectation/patient-affectation.html": 96375,
	"./generic-states/controllers/patient-by-age/patient-by-age.html": 73612,
	"./generic-states/controllers/patient-status/patient-status.html": 62081,
	"./generic-states/controllers/pregnancy-report/pregnancy-report.html": 54743,
	"./generic-states/controllers/states-setup/states-setup.html": 36861,
	"./generic-states/dialogs/general-setup/general-setup.tpl.html": 27244,
	"./generic-states/dialogs/print/print.tpl.html": 53036,
	"./hospitalization/controllers/active-hospitalizations/active-hospitalizations.html": 92868,
	"./hospitalization/dialogs/admission-form/admission-form.dialog.tpl.html": 78590,
	"./hospitalization/dialogs/clinic-location/clinic-location.dialog.tpl.html": 64435,
	"./hospitalization/dialogs/hospitalization-reason/hospitalization-reason.dialog.tpl.html": 90934,
	"./hospitalization/dialogs/hospitalization-reason/reason-general.tpl.html": 72745,
	"./hospitalization/dialogs/hospitalization-reason/reason-interventions.tpl.html": 34112,
	"./hospitalization/dialogs/hospitalization-reason/reason-procedures.tpl.html": 81098,
	"./hospitalization/dialogs/intervention-reason/intervention-reason.dialog.tpl.html": 94673,
	"./medical-care/views/medical-care-container.html": 95874,
	"./medical-care/views/medical-care-files.html": 64407,
	"./medical-care/views/medical-care-form.html": 17815,
	"./medical-care/views/medical-care-list.html": 1924,
	"./medical-care/views/medical-care-medical-file.html": 84956,
	"./medical-care/views/medical-care-procedure-dialog.tpl.html": 40619,
	"./medical-care/views/medical-care-procedure-groups-dialog.tpl.html": 23255,
	"./medical-care/views/medical-care-procedure-search-dialog.tpl.html": 62342,
	"./medical-care/views/medical-care-scheduling.html": 51287,
	"./medical-care/views/medical-care-scheduling.tpl.html": 28707,
	"./medical-care/views/medical-care.tpl.html": 58215,
	"./medical-care/views/medical-plan-procedures.tpl.html": 46445,
	"./medical-care/views/scheduling-dialog.tpl.html": 41401,
	"./oximetry/views/break-dialog.tpl.html": 57743,
	"./oximetry/views/files-select-dialog.tpl.html": 63966,
	"./oximetry/views/oximetry-body.tpl.html": 7890,
	"./oximetry/views/oximetry-chart.tpl.html": 15350,
	"./oximetry/views/oximetry-config-table.tpl.html": 13108,
	"./oximetry/views/oximetry.tpl.html": 59577,
	"./parameters/controllers/app-backup/app-backup-main.html": 60646,
	"./parameters/controllers/app-backup/app-backup-secondary.html": 34009,
	"./parameters/controllers/app-backup/app-backup.html": 37186,
	"./parameters/controllers/convention-setup/convention-setup.html": 25809,
	"./parameters/controllers/dcm-config/dcm-aet.tpl.html": 83935,
	"./parameters/controllers/dcm-config/dcm-container.html": 28094,
	"./parameters/controllers/dcm-config/dcm-fire-pacs.tpl.html": 32959,
	"./parameters/controllers/dcm-config/dcm-modalities.tpl.html": 15886,
	"./parameters/controllers/dcm-config/dcm-requested-procedures.tpl.html": 92262,
	"./parameters/controllers/dcm-config/dcm-services.tpl.html": 36527,
	"./parameters/controllers/dcm-config/dcm-viewer-config.tpl.html": 50968,
	"./parameters/controllers/diagnostics-setup/diagnostics-setup.html": 63265,
	"./parameters/controllers/diagnostics-setup/general.html": 35966,
	"./parameters/controllers/diagnostics-setup/pathologies.html": 17980,
	"./parameters/controllers/editor-contextual-model-setup/editor-contextual-model-setup.html": 84816,
	"./parameters/controllers/extranet-setup/extranet-api-setup.html": 32365,
	"./parameters/controllers/server-panel/server-panel.html": 73313,
	"./parameters/dialogs/app-alert/app-alert-dialog.tpl.html": 73996,
	"./parameters/dialogs/app-backup-config/app-backup-config-dialog.tpl.html": 80807,
	"./parameters/dialogs/app-backup-error/app-backup-error-dialog.tpl.html": 80475,
	"./parameters/dialogs/app-backup/app-backup-dialog.tpl.html": 30715,
	"./parameters/dialogs/consent-model-form/consent-model-form-dialog.tpl.html": 21593,
	"./parameters/dialogs/device-driver-form/device-driver-form-dialog.tpl.html": 4118,
	"./parameters/dialogs/form-template-category/form-template-category-dialog.tpl.html": 95268,
	"./parameters/dialogs/procedure-form/procedure-form-dialog.tpl.html": 11566,
	"./parameters/dialogs/visit-forms-submodule/visit-forms-submodule-dialog.tpl.html": 20629,
	"./parameters/views/accounts-service-table.tpl.html": 74338,
	"./parameters/views/accounts-setup.html": 3621,
	"./parameters/views/accounts-table.tpl.html": 11731,
	"./parameters/views/adv-observation-form.tpl.html": 50540,
	"./parameters/views/adv-observation-indications.tpl.html": 50049,
	"./parameters/views/adv-observation-medical-file.tpl.html": 56569,
	"./parameters/views/adv-observation-types.tpl.html": 81171,
	"./parameters/views/affiliation-edit-tpl.html": 21954,
	"./parameters/views/agenda-config-list.html": 85725,
	"./parameters/views/agenda-config.html": 94954,
	"./parameters/views/agenda-events-config.html": 31457,
	"./parameters/views/agenda-general-config.html": 99538,
	"./parameters/views/agenda-physician-color-config.html": 93611,
	"./parameters/views/agenda-reason-color-config.html": 65603,
	"./parameters/views/agenda-room-config.html": 38180,
	"./parameters/views/biology-details-not-unique-header.tpl.html": 30756,
	"./parameters/views/biology-details-not-unique.tpl.html": 81326,
	"./parameters/views/biology-details-unique.tpl.html": 78626,
	"./parameters/views/biology-models-table.tpl.html": 3445,
	"./parameters/views/biology-models.tpl.html": 11964,
	"./parameters/views/biology-parameter-dialog.tpl.html": 22046,
	"./parameters/views/biology-parameters-table.tpl.html": 95383,
	"./parameters/views/biology-parameters.tpl.html": 72329,
	"./parameters/views/biology-setup.html": 31582,
	"./parameters/views/block-setup-form.html": 65892,
	"./parameters/views/block-setup.html": 14228,
	"./parameters/views/bulk-import-patient.html": 24520,
	"./parameters/views/care-sheet-printing-form.html": 72483,
	"./parameters/views/care-sheet-printing-main.html": 78005,
	"./parameters/views/certificate-category-setup.html": 5730,
	"./parameters/views/choice-list-setup.html": 76336,
	"./parameters/views/cloud-platform-dialog.tpl.html": 90142,
	"./parameters/views/cloud-platforms.html": 74675,
	"./parameters/views/consent-models-setup.html": 78746,
	"./parameters/views/consultation-setup-form.html": 73898,
	"./parameters/views/consultation-setup.html": 15027,
	"./parameters/views/contact-setup.html": 68657,
	"./parameters/views/convention-exceptions.html": 60826,
	"./parameters/views/current-patient-fields.tpl.html": 45086,
	"./parameters/views/current-patient-setup.html": 36468,
	"./parameters/views/dental-setup-general.tpl.html": 46230,
	"./parameters/views/dental-setup-procedure-groups.tpl.html": 91503,
	"./parameters/views/dental-setup-procedures.tpl.html": 4873,
	"./parameters/views/dental-setup.html": 12339,
	"./parameters/views/device-drivers.html": 74258,
	"./parameters/views/devices-config.html": 41276,
	"./parameters/views/dictionary-setup.html": 33114,
	"./parameters/views/email-models-setup.html": 57725,
	"./parameters/views/email-sms-setup.html": 35819,
	"./parameters/views/email-sms-user-setup.html": 93058,
	"./parameters/views/establishment.html": 29031,
	"./parameters/views/exam-form-setup.html": 11122,
	"./parameters/views/exam-list-setup.html": 23379,
	"./parameters/views/exam-models-setup.html": 965,
	"./parameters/views/exam-setup.html": 78942,
	"./parameters/views/exam-template-dialog.tpl.html": 67392,
	"./parameters/views/external-patient-api-fields.tpl.html": 74572,
	"./parameters/views/external-patient-api-menu.tpl.html": 40677,
	"./parameters/views/external-patient-api.html": 36280,
	"./parameters/views/form-templates-container.html": 95106,
	"./parameters/views/general-app-config.html": 52390,
	"./parameters/views/general-billing-config.html": 9784,
	"./parameters/views/general-config.html": 46660,
	"./parameters/views/general-main-toolbar-config.html": 36521,
	"./parameters/views/general-prescription-config.html": 86578,
	"./parameters/views/general-stock-config.html": 55475,
	"./parameters/views/general-system-config.html": 69172,
	"./parameters/views/general-visit-config.html": 22284,
	"./parameters/views/general-workflow-config.html": 46444,
	"./parameters/views/hospitalization-setup-beds.tpl.html": 78377,
	"./parameters/views/hospitalization-setup-floors.tpl.html": 80699,
	"./parameters/views/hospitalization-setup-intervention-reason.tpl.html": 65684,
	"./parameters/views/hospitalization-setup-procedures.tpl.html": 79219,
	"./parameters/views/hospitalization-setup-reason.tpl.html": 2376,
	"./parameters/views/hospitalization-setup-rooms.tpl.html": 32976,
	"./parameters/views/hospitalization-setup.html": 10105,
	"./parameters/views/html-field-dialog.tpl.html": 74471,
	"./parameters/views/list-setup-container.html": 19583,
	"./parameters/views/location-setup-city.tpl.html": 96941,
	"./parameters/views/location-setup-country.tpl.html": 2990,
	"./parameters/views/location-setup-province.tpl.html": 73233,
	"./parameters/views/location-setup.html": 50716,
	"./parameters/views/main.html": 31540,
	"./parameters/views/measures-dialog.tpl.html": 53137,
	"./parameters/views/measures-setup.html": 32787,
	"./parameters/views/medical-care-general.html": 85743,
	"./parameters/views/medical-care-procedure-groups.html": 44424,
	"./parameters/views/medical-care-procedures.html": 8623,
	"./parameters/views/medical-care-protocols.html": 75328,
	"./parameters/views/medical-care-setup.html": 98274,
	"./parameters/views/medicine-setup-list.html": 96829,
	"./parameters/views/medicine-setup.html": 4906,
	"./parameters/views/mobile-app-access.tpl.html": 43980,
	"./parameters/views/mobile-app-consultation.tpl.html": 86745,
	"./parameters/views/mobile-app-patient.tpl.html": 17881,
	"./parameters/views/mobile-app-setup.html": 1746,
	"./parameters/views/mobile-patient-tablet.tpl.html": 49398,
	"./parameters/views/mobile-tablet-background.tpl.html": 73056,
	"./parameters/views/observation-setup.html": 50945,
	"./parameters/views/operator-edit-tpl.html": 32935,
	"./parameters/views/organization.html": 58181,
	"./parameters/views/oximetry-config.html": 99409,
	"./parameters/views/oxymetry-config-chart-colors.html": 22915,
	"./parameters/views/oxymetry-config-general.html": 81227,
	"./parameters/views/oxymetry-config-protocols.html": 3297,
	"./parameters/views/oxymetry-config-reasons.html": 27501,
	"./parameters/views/patient-file-custom-fields.tpl.html": 92886,
	"./parameters/views/patient-file-general.tpl.html": 50293,
	"./parameters/views/patient-file-required-fields.tpl.html": 41962,
	"./parameters/views/patient-file-setup.html": 53116,
	"./parameters/views/patient-file-table-columns.tpl.html": 57373,
	"./parameters/views/patient-fusion.html": 46199,
	"./parameters/views/patient-tablet-dialog.tpl.html": 4320,
	"./parameters/views/physician-contact-table.tpl.html": 4645,
	"./parameters/views/pregnancy-calendar-configs.html": 45774,
	"./parameters/views/pregnancy-calendar-setup.html": 3131,
	"./parameters/views/pregnancy-general-config.html": 34838,
	"./parameters/views/printing-defaults-form.html": 3050,
	"./parameters/views/printing-image-dialog.tpl.html": 55615,
	"./parameters/views/printing-images-form.html": 508,
	"./parameters/views/printing-template-form.html": 20478,
	"./parameters/views/printing.html": 73277,
	"./parameters/views/prisma-devices-list.tpl.html": 42078,
	"./parameters/views/prisma-order-dialog.tpl.html": 45063,
	"./parameters/views/prisma-report-loading-dialog.tpl.html": 16257,
	"./parameters/views/procedure-setup.html": 36183,
	"./parameters/views/procedures-catalog-container.html": 37918,
	"./parameters/views/profile-setup-form.html": 98801,
	"./parameters/views/profile-setup.html": 8437,
	"./parameters/views/referring-contact-table.tpl.html": 44451,
	"./parameters/views/sequence.html": 17121,
	"./parameters/views/sequence.tpl.html": 16751,
	"./parameters/views/sms-history.html": 6593,
	"./parameters/views/sms-models-setup.html": 84675,
	"./parameters/views/sms-setup.html": 95773,
	"./parameters/views/smtp-setup.html": 43271,
	"./parameters/views/specialities-config.html": 96534,
	"./parameters/views/speciality-form.tpl.html": 6297,
	"./parameters/views/stock-config-table.tpl.html": 75324,
	"./parameters/views/summary-file-setup.tpl.html": 56903,
	"./parameters/views/survey-setup-form-meanings.tpl.html": 312,
	"./parameters/views/survey-setup-form-questions.tpl.html": 11781,
	"./parameters/views/survey-setup-form.html": 83797,
	"./parameters/views/survey-setup.html": 37177,
	"./parameters/views/tablet-survey.html": 473,
	"./parameters/views/technician-setup.html": 92774,
	"./parameters/views/vaccination-calendar-configs.html": 6294,
	"./parameters/views/vaccination-calendar-general.html": 42136,
	"./parameters/views/vaccination-calendar-setup.html": 82617,
	"./parameters/views/vaccination-calendar-vaccines.html": 13629,
	"./patient/measure-blocks/boolean-field.tpl.html": 50958,
	"./patient/measure-blocks/calculated-field.tpl.html": 43605,
	"./patient/measure-blocks/date-field.tpl.html": 34734,
	"./patient/measure-blocks/float-field.tpl.html": 63493,
	"./patient/measure-blocks/integer-field.tpl.html": 78605,
	"./patient/measure-blocks/string-field.tpl.html": 62224,
	"./patient/views/bulk-impot-dialog.tpl.html": 17455,
	"./patient/views/coordinate.html": 78197,
	"./patient/views/ext-api-search-dialog.tpl.html": 3254,
	"./patient/views/insurance-list.html": 66982,
	"./patient/views/insurance.html": 65443,
	"./patient/views/main.html": 93865,
	"./patient/views/measurement-chart-dialog.tpl.html": 74799,
	"./patient/views/measurement-form-dialog.tpl.html": 6157,
	"./patient/views/measurement-history-dialog.tpl.html": 63314,
	"./patient/views/measurement.tpl.html": 27804,
	"./patient/views/medical-file.tpl.html": 94497,
	"./patient/views/multi-patient-search-dialog.tpl.html": 85028,
	"./patient/views/patient-alerts-dialog.tpl.html": 46881,
	"./patient/views/patient-category-dialog.tpl.html": 85973,
	"./patient/views/patient-form.html": 86930,
	"./patient/views/patient-list.html": 50970,
	"./patient/views/patient-relations-dialog.tpl.html": 92721,
	"./patient/views/patient-search-dialog.tpl.html": 32267,
	"./patient/views/summary-field.tpl.html": 75098,
	"./patient/views/summary-string-field.tpl.html": 10327,
	"./patient/views/summary-url-list.tpl.html": 73581,
	"./patient/views/vaccination-dialog.tpl.html": 64455,
	"./patient/views/vaccination.tpl.html": 59472,
	"./payment/views/account-balance.html": 89146,
	"./payment/views/account-details-dialog.tpl.html": 49314,
	"./payment/views/account-details.tpl.html": 38275,
	"./payment/views/dental-treatment-plans.html": 49584,
	"./payment/views/encasement-details.tpl.html": 95033,
	"./payment/views/encasement.html": 41803,
	"./payment/views/entry-payment.tpl.html": 53627,
	"./payment/views/entry-pre-payment.tpl.html": 78634,
	"./payment/views/financial-statement-container.html": 21618,
	"./payment/views/general-account.html": 82305,
	"./payment/views/medical-plan-payment-dialog.tpl.html": 55139,
	"./payment/views/medical-plans.html": 61926,
	"./payment/views/patient-financial-statement-container.html": 97755,
	"./payment/views/payment-form-bottom.html": 37143,
	"./payment/views/payment-form-top.html": 45795,
	"./payment/views/payment-form.html": 78855,
	"./payment/views/payment-list.html": 77256,
	"./payment/views/payment-main.html": 70475,
	"./payment/views/treatment-plan-payment-dialog.tpl.html": 27741,
	"./payment/views/visits.html": 60658,
	"./prescription/components/biology-table/biology-table.tpl.html": 59712,
	"./prescription/components/legacy-biology-table/legacy-biology-table.tpl.html": 98092,
	"./prescription/components/prescription-item/biology-prescription-item.tpl.html": 45648,
	"./prescription/components/prescription-item/care-prescription-item.tpl.html": 63258,
	"./prescription/components/prescription-item/medical-prescription-item.tpl.html": 42632,
	"./prescription/components/prescription-item/prescription-item.tpl.html": 68691,
	"./prescription/components/prescription-item/procedure-prescription-item.tpl.html": 55947,
	"./prescription/components/prescription-item/text-prescription-item.tpl.html": 43547,
	"./prescription/controllers/biology-prescription-form/biology-prescription-form.html": 70625,
	"./prescription/controllers/care-prescription-form/care-prescription-form.html": 98247,
	"./prescription/controllers/medical-prescription-form/body-container.html": 12201,
	"./prescription/controllers/medical-prescription-form/detail-container.html": 95640,
	"./prescription/controllers/medical-prescription-form/detail-generator.html": 86334,
	"./prescription/controllers/medical-prescription-form/medical-prescription-form.html": 53626,
	"./prescription/controllers/prescription-container/prescription-container.html": 67646,
	"./prescription/controllers/prescription-list/prescription-list.html": 74811,
	"./prescription/controllers/prescription-view/prescription-view.html": 18034,
	"./prescription/controllers/procedure-prescription-form/procedure-prescription-form.html": 27448,
	"./prescription/controllers/text-prescription-form/text-prescription-form.html": 31513,
	"./prescription/dialogs/biology-result-dialog/biology-result-dialog.tpl.html": 33287,
	"./prescription/dialogs/biology-resume-dialog/biology-resume-dialog.tpl.html": 38669,
	"./prescription/directives/biology-row/details-not-unique-header.tpl.html": 61979,
	"./prescription/directives/biology-row/details-not-unique.tpl.html": 21453,
	"./prescription/directives/biology-row/details-unique.tpl.html": 26351,
	"./rehabilitation/views/current-exams.html": 90828,
	"./rehabilitation/views/device-dialog.tpl.html": 44281,
	"./rehabilitation/views/devices.tpl.html": 64769,
	"./rehabilitation/views/exams-list.html": 24956,
	"./rehabilitation/views/rehabilitation.html": 75623,
	"./rehabilitation/views/settings.html": 79914,
	"./rehabilitation/views/training-block.tpl.html": 84490,
	"./shared/views/biology-tree.tpl.html": 32409,
	"./shared/views/contact-dialog.tpl.html": 26828,
	"./shared/views/contacts-list.html": 63881,
	"./shared/views/convention-dialog.tpl.html": 53892,
	"./shared/views/convention-search-dialog.tpl.html": 57476,
	"./shared/views/custom-contact.tpl.html": 21410,
	"./shared/views/email-sharing-dialog.tpl.html": 52966,
	"./shared/views/filter-dialog.tpl.html": 37430,
	"./shared/views/list.custom-list.tpl.html": 30647,
	"./shared/views/list.default.tpl.html": 29072,
	"./shared/views/list.dosage-form.tpl.html": 17295,
	"./shared/views/list.prescription-frequency.tpl.html": 17784,
	"./shared/views/list.sport-team-category.tpl.html": 24332,
	"./shared/views/list.title.tpl.html": 51639,
	"./shared/views/loader.html": 39987,
	"./shared/views/location-dialog.tpl.html": 36632,
	"./shared/views/main.html": 7258,
	"./shared/views/medicine-dialog.tpl.html": 53210,
	"./shared/views/medicine-posologies.tpl.html": 43285,
	"./shared/views/medicine-search-dialog.tpl.html": 85443,
	"./shared/views/notification-dialog.tpl.html": 48726,
	"./shared/views/notification-list-dialog.tpl.html": 98452,
	"./shared/views/notification.tpl.html": 37952,
	"./shared/views/organization-dialog.tpl.html": 31685,
	"./shared/views/print.tpl.html": 3109,
	"./shared/views/procedure-dialog.tpl.html": 61391,
	"./shared/views/procedure-table.tpl.html": 37720,
	"./shared/views/prompt-dialog.tpl.html": 44742,
	"./shared/views/report-as-entry-type.tpl.html": 72708,
	"./shared/views/side-nav.tpl.html": 66119,
	"./shared/views/sms-sending-dialog.tpl.html": 98621,
	"./shared/views/style.tpl.html": 36475,
	"./shared/views/table-custom-filter.html": 82084,
	"./shared/views/table-filter-item.html": 16616,
	"./shared/views/table-sidenav.html": 89378,
	"./shared/views/table-style-rules.html": 50157,
	"./shared/views/table.tpl.html": 91622,
	"./shared/views/text-editor-custom.tpl.html": 64653,
	"./shared/views/toolbar.tpl.html": 45329,
	"./shared/views/vaccine-dialog.tpl.html": 51089,
	"./shared/views/voice-recognition-dialog.tpl.html": 66421,
	"./shared/views/web-cam-dialog.tpl.html": 1618,
	"./specifics/components/custom-classification-field/custom-classification-field.tpl.html": 97437,
	"./specifics/components/diagnostics-block/diagnostics-block.tpl.html": 17296,
	"./specifics/components/icd-field/icd-field.tpl.html": 63989,
	"./specifics/components/osiics-field/osiics-field.tpl.html": 44225,
	"./specifics/components/pregnancy-block/pregnancy-block.tpl.html": 61924,
	"./specifics/components/pregnancy-term/pregnancy-term.tpl.html": 78979,
	"./specifics/components/vaccination-calendar-block/vaccination-calendar-block.tpl.html": 63536,
	"./specifics/dialogs/birth-validation-dialog/birth-validation-dialog.tpl.html": 23535,
	"./specifics/dialogs/osiics-classification-dialog/osiics-classification.tpl.html": 38674,
	"./specifics/dialogs/pregnancy-event-form-dialog/pregnancy-event-form.tpl.html": 86499,
	"./specifics/dialogs/pregnancy-milestone-form-dialog/pregnancy-milestone-form.tpl.html": 98228,
	"./specifics/dialogs/service-order-scheduling-dialog/service-order-scheduling-dialog.tpl.html": 47403,
	"./specifics/dialogs/vaccination-config-container-dialog/vaccination-config-container.tpl.html": 13675,
	"./specifics/dialogs/vaccination-config-form-dialog/vaccination-config-form.tpl.html": 75494,
	"./specifics/dialogs/vaccination-line-form-dialog/vaccination-line-form.tpl.html": 53919,
	"./specifics/dialogs/vaccine-form-dialog/vaccine-form.tpl.html": 96953,
	"./specifics/svg/human-skeleton-back.svg": 33064,
	"./specifics/svg/human-skeleton-front.svg": 68870,
	"./specifics/views/growth-charts.tpl.html": 68828,
	"./specifics/views/growth-setup.tpl.html": 47909,
	"./specifics/views/gynecology-info.tpl.html": 67879,
	"./specifics/views/human-skeleton.tpl.html": 60785,
	"./specifics/views/hur-exam.html": 93686,
	"./specifics/views/ophthalmic-prescription.tpl.html": 60805,
	"./specifics/views/pathologies-form.tpl.html": 79654,
	"./specifics/views/pt-block.tpl.html": 38904,
	"./specifics/views/traumato-container.html": 63586,
	"./stand-alone/blocks/components/custom-fields-block/custom-fields-block.tpl.html": 94579,
	"./stand-alone/blocks/components/custom-fields-table/custom-fields-table.tpl.html": 29153,
	"./stand-alone/blocks/components/form-html-block/form-html-block.tpl.html": 49685,
	"./stand-alone/blocks/components/html-block/form-block.tpl.html": 48217,
	"./stand-alone/blocks/components/html-block/html-block.tpl.html": 53997,
	"./stand-alone/blocks/components/html-block/survey-block.tpl.html": 19166,
	"./stand-alone/blocks/components/survey-question/survey-question.tpl.html": 57736,
	"./stand-alone/blocks/components/survey-resume/survey-resume.tpl.html": 98383,
	"./stand-alone/blocks/dialogs/dictionary-history-dialog/dictionary-history-dialog.tpl.html": 94603,
	"./stand-alone/blocks/views/autocomplete.tpl.html": 19402,
	"./stand-alone/blocks/views/choice-list.tpl.html": 50725,
	"./stand-alone/blocks/views/dictionary-chip-edition-dialog.tpl.html": 26589,
	"./stand-alone/blocks/views/dictionary-models-dialog.tpl.html": 44135,
	"./stand-alone/blocks/views/dictionary-multi-node-dialog.tpl.html": 73260,
	"./stand-alone/blocks/views/dictionary-new-entry-dialog.tpl.html": 40437,
	"./stand-alone/blocks/views/dictionary-tree-view.tpl.html": 19694,
	"./stand-alone/blocks/views/dictionary-tree.tpl.html": 51611,
	"./stand-alone/blocks/views/dictionary.tpl.html": 75298,
	"./stand-alone/blocks/views/file-block.tpl.html": 26421,
	"./stand-alone/blocks/views/free-dictionary.tpl.html": 55546,
	"./stand-alone/dcm/dialogs/aet/aet-dialog.tpl.html": 36976,
	"./stand-alone/dcm/dialogs/dcm-instances/dcm-instances-dialog.tpl.html": 33153,
	"./stand-alone/dcm/dialogs/dcm-order/dcm-order-dialog.tpl.html": 26567,
	"./stand-alone/dcm/dialogs/dcm-viewer/dcm-viewer-dialog.tpl.html": 16078,
	"./stand-alone/dcm/dialogs/fire-pacs-studies/fire-pacs-studies-dialog.tpl.html": 67348,
	"./stand-alone/dcm/dialogs/requested-procedure/requested-procedure-dialog.tpl.html": 17047,
	"./stand-alone/file-manager/views/audio-record-dialog.tpl.html": 21867,
	"./stand-alone/file-manager/views/contextual-files.tpl.html": 84411,
	"./stand-alone/file-manager/views/dental-file-upload-dialog.tpl.html": 93762,
	"./stand-alone/file-manager/views/excel-viewer.tpl.html": 95459,
	"./stand-alone/file-manager/views/file-update-dialog.tpl.html": 97733,
	"./stand-alone/file-manager/views/files.html": 66253,
	"./stand-alone/file-manager/views/grid-item.html": 31820,
	"./stand-alone/file-manager/views/image-editor.tpl.html": 29156,
	"./stand-alone/file-manager/views/list-item.html": 36591,
	"./stand-alone/file-manager/views/pdf-viewer.tpl.html": 29842,
	"./stand-alone/file-manager/views/tag-item.html": 21822,
	"./stand-alone/file-manager/views/visualize-file-dialog.tpl.html": 3863,
	"./stand-alone/image-edition/views/actions.tpl.html": 11142,
	"./stand-alone/image-edition/views/brightness-option.tpl.html": 20966,
	"./stand-alone/image-edition/views/contrast-option.tpl.html": 20668,
	"./stand-alone/image-edition/views/crop-option.html": 766,
	"./stand-alone/image-edition/views/drawing-option.tpl.html": 66849,
	"./stand-alone/image-edition/views/form-option.tpl.html": 32041,
	"./stand-alone/image-edition/views/image-edition.tpl.html": 9982,
	"./stand-alone/image-edition/views/options.tpl.html": 67077,
	"./stand-alone/image-edition/views/police-option.tpl.html": 82327,
	"./stand-alone/interfacing/views/date-time-field.tpl.html": 12465,
	"./stand-alone/interfacing/views/import-exam-dialog.tpl.html": 7670,
	"./stand-alone/interfacing/views/order-form-dialog.tpl.html": 210,
	"./stand-alone/patient-summary/views/certificates-list.tpl.html": 7082,
	"./stand-alone/patient-summary/views/consultation.tpl.html": 70369,
	"./stand-alone/patient-summary/views/consultations-list.tpl.html": 12234,
	"./stand-alone/patient-summary/views/exams-list.tpl.html": 70927,
	"./stand-alone/patient-summary/views/filters-dialog.tpl.html": 84326,
	"./stand-alone/patient-summary/views/main.tpl.html": 98219,
	"./stand-alone/patient-summary/views/prescriptions-list.tpl.html": 23595,
	"./stand-alone/patient-summary/views/summary-dialog.tpl.html": 85962,
	"./stand-alone/patient-summary/views/visit.tpl.html": 67669,
	"./stand-alone/sport-data/components/sport-file-details/sport-file-details.tpl.html": 16252,
	"./stand-alone/sport-data/components/sport-file/sport-file.tpl.html": 35519,
	"./stand-alone/sport-data/controllers/sport-data-setup/sport-data-general.html": 90279,
	"./stand-alone/sport-data/controllers/sport-data-setup/sport-data-organizations.html": 40580,
	"./stand-alone/sport-data/controllers/sport-data-setup/sport-data-setup.html": 9284,
	"./stand-alone/sport-data/dialogs/sport-organization/sport-organization-dialog.tpl.html": 99467,
	"./stand-alone/table/views/table-column-menu.html": 82258,
	"./stand-alone/table/views/table-date-search.html": 5095,
	"./stand-alone/table/views/table-main.html": 35825,
	"./stand-alone/table/views/table-select-search.html": 56821,
	"./stand-alone/table/views/table-text-search.html": 73675,
	"./stand-alone/technical-file/components/technical-file/technical-file.tpl.html": 11516,
	"./stand-alone/technical-file/controllers/technical-file-setup/technical-file-fields.html": 81012,
	"./stand-alone/technical-file/controllers/technical-file-setup/technical-file-general.html": 63598,
	"./stand-alone/technical-file/controllers/technical-file-setup/technical-file-lists.html": 53290,
	"./stand-alone/technical-file/controllers/technical-file-setup/technical-file-setup.html": 14154,
	"./stand-alone/technical-file/dialogs/advanced-filter/advenced-filter-dialog.tpl.html": 18960,
	"./stand-alone/text-editor/components/sms-editor/sms-editor.tpl.html": 94464,
	"./stand-alone/text-editor/dialogs/custom-var/custom-var-form.tpl.html": 59559,
	"./stand-alone/text-editor/dialogs/custom-var/custom-var.tpl.html": 10750,
	"./stand-alone/text-editor/dialogs/editor-contextual-template-form/editor-contextual-template-form.tpl.html": 34780,
	"./stand-alone/text-editor/dialogs/editor-contextual-templates/editor-contextual-templates.tpl.html": 96115,
	"./stand-alone/text-editor/dialogs/fill-custom-var/fill-custom-var.tpl.html": 5125,
	"./stand-alone/video-call/dialogs/video-call/video-call.dialog.html": 86076,
	"./stock/views/article-complementary-code.html": 39585,
	"./stock/views/article-components.html": 21554,
	"./stock/views/article-form-dialog.tpl.html": 92298,
	"./stock/views/article-form.html": 3346,
	"./stock/views/article-historic.tpl.html": 99028,
	"./stock/views/article-list.html": 9085,
	"./stock/views/article-main.html": 5990,
	"./stock/views/article-medicine-form.html": 42022,
	"./stock/views/article-medicine-main.html": 23718,
	"./stock/views/article-search-modal.tpl.html": 41525,
	"./stock/views/article-substitution.html": 32673,
	"./stock/views/articles-shortages-historic.html": 73783,
	"./stock/views/bar-code-scan.tpl.html": 37232,
	"./stock/views/business-detail-dialog.tpl.html": 74257,
	"./stock/views/business-detail-list.html": 69164,
	"./stock/views/charge-dialog.tpl.html": 80955,
	"./stock/views/comment-dialog.tpl.html": 32241,
	"./stock/views/comment-preview.tpl.html": 42790,
	"./stock/views/consigned-lots-return-dialog.tpl.html": 33774,
	"./stock/views/consignment-form.html": 15853,
	"./stock/views/consignment-return-form.html": 72835,
	"./stock/views/credit-note-form.html": 57845,
	"./stock/views/customer-order-form.html": 88062,
	"./stock/views/delivery-form.html": 19249,
	"./stock/views/delivery-return-form.html": 62315,
	"./stock/views/deposition-form.html": 8076,
	"./stock/views/deposition-lots-dialog.tpl.html": 89314,
	"./stock/views/document-comment.tpl.html": 67917,
	"./stock/views/document-lines-header.tpl.html": 54254,
	"./stock/views/document-search-modal.tpl.html": 9203,
	"./stock/views/expired-articles-historic.html": 9915,
	"./stock/views/family-dialog.tpl.html": 6981,
	"./stock/views/family-list.html": 33659,
	"./stock/views/generate-delivery-form-dialog.tpl.html": 34800,
	"./stock/views/generate-stock-doc-dialog.tpl.html": 65442,
	"./stock/views/in-lots-dialog.tpl.html": 63527,
	"./stock/views/in-serials-dialog.tpl.html": 78879,
	"./stock/views/inventory-form.html": 64734,
	"./stock/views/inventory-lines.tpl.html": 11900,
	"./stock/views/inventory-lots-dialog.tpl.html": 55359,
	"./stock/views/inventory-serials-dialog.tpl.html": 80544,
	"./stock/views/invoice-form.html": 95721,
	"./stock/views/lots-dialog.tpl.html": 16608,
	"./stock/views/merge-documents-dialog.tpl.html": 29750,
	"./stock/views/movement-form.html": 16988,
	"./stock/views/movement-state.html": 51538,
	"./stock/views/movements-by-business-state.html": 44855,
	"./stock/views/opening-balance-form.html": 82226,
	"./stock/views/order-form.html": 38734,
	"./stock/views/out-lots-dialog.tpl.html": 6024,
	"./stock/views/out-serials-dialog.tpl.html": 98698,
	"./stock/views/patient-movement-state.html": 6132,
	"./stock/views/price-request-form.html": 21321,
	"./stock/views/price-request-response.tpl.html": 46543,
	"./stock/views/provider-dialog.tpl.html": 8150,
	"./stock/views/provider-list.html": 81837,
	"./stock/views/provider-search-modal.tpl.html": 35241,
	"./stock/views/purchase-request.html": 75689,
	"./stock/views/recalculate-article-stock.html": 86773,
	"./stock/views/receipt-form.html": 22328,
	"./stock/views/return-form.html": 89349,
	"./stock/views/serials-dialog.tpl.html": 76101,
	"./stock/views/serials-lots-state.html": 10488,
	"./stock/views/stock-doc-actions.tpl.html": 99710,
	"./stock/views/stock-document-details.tpl.html": 7651,
	"./stock/views/stock-document-lines.tpl.html": 64781,
	"./stock/views/stock-document-list.html": 21539,
	"./stock/views/stock.html": 47212,
	"./stock/views/tariff-details-dialog.tpl.html": 5715,
	"./stock/views/tariff-details.tpl.html": 33629,
	"./stock/views/tariff.html": 51455,
	"./stock/views/transformation-form.html": 18239,
	"./stock/views/warehouse-dialog.tpl.html": 10712,
	"./stock/views/warehouse-exchange-form.html": 94230,
	"./stock/views/warehouse-exchange-historic.html": 20914,
	"./stock/views/warehouse-list.html": 92376,
	"./visit/views/errors-visit-dialog.tpl.html": 20445,
	"./visit/views/payable-payments.tpl.html": 87727,
	"./visit/views/visit-financial.tpl.html": 72089,
	"./visit/views/visit-list.html": 70285,
	"./visit/views/visit-procedures.tpl.html": 1384,
	"./visit/views/visit.main.html": 33095,
	"./workflow/components/workflow-filter/workflow-filter.html": 50143,
	"./workflow/controllers/daily-workflow/daily-workflow.html": 6194,
	"./workflow/controllers/service-order/service-order-workflow.html": 14297,
	"./workflow/controllers/workflow-container/workflow-container.html": 61897,
	"./workflow/dialogs/service-order-preview/service-order-preview.tpl.html": 45016,
	"auth/controllers/auth-form/auth-form.html": 78534,
	"auth/views/account-update-dialog.tpl.html": 12925,
	"auth/views/auth-verification-dialog.tpl.html": 70758,
	"auth/views/profile-dialog.tpl.html": 21250,
	"auth/views/service-dialog.tpl.html": 99559,
	"auth/views/service-form.tpl.html": 30215,
	"auth/views/staff-dialog.tpl.html": 76847,
	"auth/views/tokens-dialog.tpl.html": 17340,
	"billing/dialogs/care-plan-search/care-plan-search-dialog.tpl.html": 99445,
	"billing/dialogs/invoice-beneficiary-choice/invoice-beneficiary-choice.tpl.html": 73119,
	"billing/views/billing-credit-note-list.html": 58357,
	"billing/views/billing-main.html": 17604,
	"billing/views/billing-workflow.html": 20556,
	"billing/views/contract-details.html": 47958,
	"billing/views/contract-form.html": 73995,
	"billing/views/contract-guest-edit-dialog.html": 22807,
	"billing/views/contract-historic.tpl.html": 38436,
	"billing/views/contract-list.html": 41090,
	"billing/views/contract-multirenew-confirm-dialog.html": 62253,
	"billing/views/contract-plan.tpl.html": 14664,
	"billing/views/contract-pointing-historic-dialog.html": 30575,
	"billing/views/contract-renew.tpl.html": 9753,
	"billing/views/contract-terminate-dialog.tpl.html": 71427,
	"billing/views/credit-note-form-bottom.html": 39321,
	"billing/views/credit-note-form.html": 12676,
	"billing/views/dental-treatment-plan-search.tpl.html": 31675,
	"billing/views/expense-form-bottom.html": 49887,
	"billing/views/expense-form-header.html": 31178,
	"billing/views/expense-form.html": 31323,
	"billing/views/expense-list.html": 35755,
	"billing/views/invoice-form-bottom.html": 34855,
	"billing/views/invoice-form-header.html": 80224,
	"billing/views/invoice-form.html": 39882,
	"billing/views/invoice-list.html": 52107,
	"billing/views/patient-relations.tpl.html": 99672,
	"billing/views/pec-answer-dialog.tpl.html": 99799,
	"billing/views/pec-answers.html": 1853,
	"billing/views/pec-form-bottom.html": 37644,
	"billing/views/pec-form-header.html": 39023,
	"billing/views/pec-form.html": 16017,
	"billing/views/pec-lines.html": 7945,
	"billing/views/pec-list.html": 83127,
	"billing/views/procedure-search-modal.tpl.html": 55812,
	"billing/views/quotation-form-bottom.html": 59862,
	"billing/views/quotation-form-header.html": 90818,
	"billing/views/quotation-form.html": 95237,
	"billing/views/quotation-list.html": 36211,
	"billing/views/visit-search-modal.tpl.html": 29212,
	"cam/views/brand-dialog.html": 18153,
	"cam/views/cam-config-container.html": 42995,
	"cam/views/cam-config-item-list.html": 74731,
	"cam/views/cam-config.html": 37575,
	"cam/views/cam-default-config.html": 93467,
	"cam/views/cam-document-list-dialog.html": 12159,
	"cam/views/cam.html": 66060,
	"cam/views/category-edit-dialog.html": 60300,
	"cam/views/distributor-dialog.html": 36175,
	"cam/views/equipment-exploitation-dialog.html": 2507,
	"cam/views/equipment-exploitations.html": 60853,
	"cam/views/equipment-form.html": 3951,
	"cam/views/equipment-owner-dialog.html": 88545,
	"cam/views/equipment-owner-manager-dialog.html": 44198,
	"cam/views/equipment-site-edit-dialog.html": 3980,
	"cam/views/equipment-spare-parts.html": 28043,
	"cam/views/equipment.html": 17757,
	"cam/views/generator-edit-dialog.html": 71774,
	"cam/views/intervention-form.html": 15776,
	"cam/views/intervention-general-content.html": 9363,
	"cam/views/intervention-planning-dialog.html": 64789,
	"cam/views/intervention-step-edit-dialog.html": 32465,
	"cam/views/intervention-steps.html": 71589,
	"cam/views/intervention.html": 12294,
	"cam/views/maintainer-dialog.html": 33193,
	"cam/views/maintenance-group-dialog.html": 89818,
	"cam/views/manufacturer-dialog.html": 42073,
	"cam/views/spare-part-dialog.html": 53688,
	"care-sheet/views/care-sheet-container.html": 81971,
	"care-sheet/views/care-sheet-form-bottom.html": 60085,
	"care-sheet/views/care-sheet-form-header.html": 46822,
	"care-sheet/views/care-sheet-form.html": 63924,
	"care-sheet/views/care-sheet-main.html": 72431,
	"care-sheet/views/dental-base-quotation-search-modal.tpl.html": 26988,
	"care-sheet/views/dental-consultation-search-modal.tpl.html": 79685,
	"care-sheet/views/print-sheet.tpl.html": 44895,
	"certificate/views/category.tpl.html": 93065,
	"certificate/views/certificate-container.html": 25715,
	"certificate/views/certificate-form.html": 82072,
	"certificate/views/certificate-item.tpl.html": 88056,
	"certificate/views/certificate-list.html": 53980,
	"certificate/views/certificate-view.html": 22934,
	"consultation/components/consultation-body/consultation-body.tpl.html": 92432,
	"consultation/controllers/consultation-body/consultation-body.html": 4065,
	"consultation/controllers/consultation-container/consultation-container.html": 84856,
	"consultation/controllers/mobile-consultation/mobile-consultation.html": 9332,
	"consultation/controllers/observation/observation.html": 7506,
	"dental-consultation/svg/dental-12-years-compiled.svg": 2517,
	"dental-consultation/svg/dental-12-years.svg": 23409,
	"dental-consultation/svg/dental-13-and-half-compiled.svg": 53959,
	"dental-consultation/svg/dental-13-and-half.svg": 54866,
	"dental-consultation/svg/dental-6-years-compiled.svg": 13100,
	"dental-consultation/svg/dental-6-years.svg": 25974,
	"dental-consultation/svg/dental-7-and-half-compiled.svg": 7861,
	"dental-consultation/svg/dental-7-and-half.svg": 12497,
	"dental-consultation/svg/dental-adult-compiled.svg": 27159,
	"dental-consultation/svg/dental-adult.svg": 2537,
	"dental-consultation/svg/dental-child-compiled.svg": 99595,
	"dental-consultation/svg/dental-child.svg": 41426,
	"dental-consultation/svg/incisor-compiled.svg": 9866,
	"dental-consultation/svg/incisor.svg": 83907,
	"dental-consultation/svg/molar-compiled.svg": 27865,
	"dental-consultation/svg/molar.svg": 94073,
	"dental-consultation/svg/perio-buccal-bottom-left.svg": 17717,
	"dental-consultation/svg/perio-buccal-bottom-right.svg": 47876,
	"dental-consultation/svg/perio-buccal-left.svg": 81385,
	"dental-consultation/svg/perio-buccal-right.svg": 30146,
	"dental-consultation/svg/perio-lingual-bottom-left.svg": 86135,
	"dental-consultation/svg/perio-lingual-bottom-right.svg": 31632,
	"dental-consultation/svg/perio-lingual-left.svg": 69558,
	"dental-consultation/svg/perio-lingual-right.svg": 20837,
	"dental-consultation/views/dental-chart.tpl.html": 99536,
	"dental-consultation/views/dental-container.html": 73728,
	"dental-consultation/views/dental-current-consultation-table.tpl.html": 96820,
	"dental-consultation/views/dental-current-status-table.tpl.html": 97887,
	"dental-consultation/views/dental-current-view-visit-table.tpl.html": 87807,
	"dental-consultation/views/dental-initial-status-table.tpl.html": 34536,
	"dental-consultation/views/dental-plan-stock-dialog.tpl.html": 88159,
	"dental-consultation/views/dental-procedure-chart.tpl.html": 6901,
	"dental-consultation/views/dental-procedure-dialog.tpl.html": 76110,
	"dental-consultation/views/dental-procedure-group-dialog.tpl.html": 11223,
	"dental-consultation/views/dental-quotation-detail-table.tpl.html": 45443,
	"dental-consultation/views/dental-quotation-dialog.tpl.html": 70435,
	"dental-consultation/views/dental-quotation-table.tpl.html": 53490,
	"dental-consultation/views/dental-treatment-plan-detail-table.tpl.html": 56885,
	"dental-consultation/views/dental-treatment-plan-table.tpl.html": 83286,
	"dental-consultation/views/patient-dental-container.html": 89265,
	"dental-consultation/views/patient-panoramics.tpl.html": 22741,
	"dental-consultation/views/periodontal-chart.tpl.html": 26116,
	"dental-consultation/views/periodontal-container.html": 14455,
	"dental-consultation/views/periodontal-detail.html": 63891,
	"dental-consultation/views/plan-procedure-steps-dialog.tpl.html": 75254,
	"dental-consultation/views/teeth-procedures.tpl.html": 56355,
	"dental-consultation/views/tooth-action-menu.tpl.html": 56407,
	"dental-consultation/views/tooth-historic-dialog.tpl.html": 21996,
	"dental-consultation/views/tooth-surface-dialog.tpl.html": 2559,
	"dental-consultation/views/treatment-plan-dialog.tpl.html": 80117,
	"exam/components/exam-links/exam-links.tpl.html": 14598,
	"exam/controllers/exam-container/exam-container.html": 2673,
	"exam/controllers/exam-form/exam-form.html": 27138,
	"exam/controllers/exam-list/exam-list.html": 58305,
	"exam/controllers/exam-model-form/exam-model-form.html": 40623,
	"exam/controllers/exam-view/exam-view.html": 68355,
	"exam/controllers/reports-main/reports-main.html": 28095,
	"exam/dialogs/move-model-dialog/move-model-dialog.tpl.html": 48467,
	"example-module/views/example.html": 54789,
	"forms/controllers/form-detail/form-detail.html": 89245,
	"forms/controllers/forms-container/forms-container.html": 18270,
	"forms/controllers/general-forms-container/general-forms-container.html": 36245,
	"forms/controllers/general-forms-detail/general-forms-detail.html": 14094,
	"forms/views/form-block.tpl.html": 12096,
	"forms/views/form-links.tpl.html": 6413,
	"forms/views/form-template.tpl.html": 38799,
	"forms/views/load-measurement-button.html": 3500,
	"frontdesk/views/agenda-dialog.tpl.html": 27488,
	"frontdesk/views/agenda-form-dialog.tpl.html": 49587,
	"frontdesk/views/agenda.html": 87835,
	"frontdesk/views/alert-form-dialog.tpl.html": 30006,
	"frontdesk/views/appointement-availability-dialog.tpl.html": 96773,
	"frontdesk/views/appointment-dialog.tpl.html": 58904,
	"frontdesk/views/appointment-resume.tpl.html": 32235,
	"frontdesk/views/appointment-search.tpl.html": 70659,
	"frontdesk/views/backgroun-event-dialog.tpl.html": 88070,
	"frontdesk/views/calendar-duration-dialog.tpl.html": 62650,
	"frontdesk/views/entry-dialog.tpl.html": 53309,
	"frontdesk/views/entry-resume-dialog.tpl.html": 35217,
	"frontdesk/views/entry-room-update-dialog.tpl.html": 48738,
	"frontdesk/views/f-ev-menu.tpl.html": 58815,
	"frontdesk/views/f-ex-menu.tpl.html": 24946,
	"frontdesk/views/f-rdv-menu.tpl.html": 40905,
	"frontdesk/views/f-sv-menu.tpl.html": 47574,
	"frontdesk/views/f-wr-menu.tpl.html": 39119,
	"frontdesk/views/front-desk-agenda-loader.html": 84191,
	"frontdesk/views/frontdesk.html": 71800,
	"frontdesk/views/group-appointment-dialog.tpl.html": 64952,
	"frontdesk/views/group-appointment-entry-dialog.tpl.html": 46808,
	"frontdesk/views/last-medical-prescription.tpl.html": 82500,
	"frontdesk/views/patient-alert.tpl.html": 8562,
	"frontdesk/views/patient-contract-resume.tpl.html": 32992,
	"frontdesk/views/patient-resume.tpl.html": 21790,
	"frontdesk/views/planning-container.html": 20749,
	"frontdesk/views/planning-details.html": 77286,
	"frontdesk/views/planning-dialog.tpl.html": 86296,
	"frontdesk/views/planning-list.html": 20580,
	"frontdesk/views/planning-visit-container.html": 3749,
	"frontdesk/views/practice.html": 86698,
	"frontdesk/views/reason-dialog.tpl.html": 1153,
	"frontdesk/views/room-dialog.tpl.html": 6209,
	"frontdesk/views/s-sv-menu.tpl.html": 54567,
	"frontdesk/views/summary-resume.tpl.html": 65706,
	"general-payment/views/payment-calculate-dialog.tpl.html": 48537,
	"general-payment/views/payment-form-body.tpl.html": 39054,
	"general-payment/views/payment-form-header.tpl.html": 98714,
	"general-payment/views/payment-form.html": 51937,
	"general-payment/views/payment-list.html": 1886,
	"general-payment/views/payment.html": 68907,
	"generic-states/components/pivot-table/pivot-table.tpl.html": 5012,
	"generic-states/controllers/activities/activities.html": 47680,
	"generic-states/controllers/appointment-report/appointment-report.html": 65047,
	"generic-states/controllers/check-checks/check-checks.html": 29779,
	"generic-states/controllers/due-dates-report/due-dates-report.html": 52167,
	"generic-states/controllers/external-treating-physician-activity/external-treating-physician-activity.html": 71240,
	"generic-states/controllers/generic-states/basic-template.html": 57869,
	"generic-states/controllers/generic-states/generic-states.html": 4052,
	"generic-states/controllers/insured-report/insured-report.html": 67798,
	"generic-states/controllers/medicine-report/medicine-report.html": 20098,
	"generic-states/controllers/patient-affectation/patient-affectation.html": 96375,
	"generic-states/controllers/patient-by-age/patient-by-age.html": 73612,
	"generic-states/controllers/patient-status/patient-status.html": 62081,
	"generic-states/controllers/pregnancy-report/pregnancy-report.html": 54743,
	"generic-states/controllers/states-setup/states-setup.html": 36861,
	"generic-states/dialogs/general-setup/general-setup.tpl.html": 27244,
	"generic-states/dialogs/print/print.tpl.html": 53036,
	"hospitalization/controllers/active-hospitalizations/active-hospitalizations.html": 92868,
	"hospitalization/dialogs/admission-form/admission-form.dialog.tpl.html": 78590,
	"hospitalization/dialogs/clinic-location/clinic-location.dialog.tpl.html": 64435,
	"hospitalization/dialogs/hospitalization-reason/hospitalization-reason.dialog.tpl.html": 90934,
	"hospitalization/dialogs/hospitalization-reason/reason-general.tpl.html": 72745,
	"hospitalization/dialogs/hospitalization-reason/reason-interventions.tpl.html": 34112,
	"hospitalization/dialogs/hospitalization-reason/reason-procedures.tpl.html": 81098,
	"hospitalization/dialogs/intervention-reason/intervention-reason.dialog.tpl.html": 94673,
	"medical-care/views/medical-care-container.html": 95874,
	"medical-care/views/medical-care-files.html": 64407,
	"medical-care/views/medical-care-form.html": 17815,
	"medical-care/views/medical-care-list.html": 1924,
	"medical-care/views/medical-care-medical-file.html": 84956,
	"medical-care/views/medical-care-procedure-dialog.tpl.html": 40619,
	"medical-care/views/medical-care-procedure-groups-dialog.tpl.html": 23255,
	"medical-care/views/medical-care-procedure-search-dialog.tpl.html": 62342,
	"medical-care/views/medical-care-scheduling.html": 51287,
	"medical-care/views/medical-care-scheduling.tpl.html": 28707,
	"medical-care/views/medical-care.tpl.html": 58215,
	"medical-care/views/medical-plan-procedures.tpl.html": 46445,
	"medical-care/views/scheduling-dialog.tpl.html": 41401,
	"oximetry/views/break-dialog.tpl.html": 57743,
	"oximetry/views/files-select-dialog.tpl.html": 63966,
	"oximetry/views/oximetry-body.tpl.html": 7890,
	"oximetry/views/oximetry-chart.tpl.html": 15350,
	"oximetry/views/oximetry-config-table.tpl.html": 13108,
	"oximetry/views/oximetry.tpl.html": 59577,
	"parameters/controllers/app-backup/app-backup-main.html": 60646,
	"parameters/controllers/app-backup/app-backup-secondary.html": 34009,
	"parameters/controllers/app-backup/app-backup.html": 37186,
	"parameters/controllers/convention-setup/convention-setup.html": 25809,
	"parameters/controllers/dcm-config/dcm-aet.tpl.html": 83935,
	"parameters/controllers/dcm-config/dcm-container.html": 28094,
	"parameters/controllers/dcm-config/dcm-fire-pacs.tpl.html": 32959,
	"parameters/controllers/dcm-config/dcm-modalities.tpl.html": 15886,
	"parameters/controllers/dcm-config/dcm-requested-procedures.tpl.html": 92262,
	"parameters/controllers/dcm-config/dcm-services.tpl.html": 36527,
	"parameters/controllers/dcm-config/dcm-viewer-config.tpl.html": 50968,
	"parameters/controllers/diagnostics-setup/diagnostics-setup.html": 63265,
	"parameters/controllers/diagnostics-setup/general.html": 35966,
	"parameters/controllers/diagnostics-setup/pathologies.html": 17980,
	"parameters/controllers/editor-contextual-model-setup/editor-contextual-model-setup.html": 84816,
	"parameters/controllers/extranet-setup/extranet-api-setup.html": 32365,
	"parameters/controllers/server-panel/server-panel.html": 73313,
	"parameters/dialogs/app-alert/app-alert-dialog.tpl.html": 73996,
	"parameters/dialogs/app-backup-config/app-backup-config-dialog.tpl.html": 80807,
	"parameters/dialogs/app-backup-error/app-backup-error-dialog.tpl.html": 80475,
	"parameters/dialogs/app-backup/app-backup-dialog.tpl.html": 30715,
	"parameters/dialogs/consent-model-form/consent-model-form-dialog.tpl.html": 21593,
	"parameters/dialogs/device-driver-form/device-driver-form-dialog.tpl.html": 4118,
	"parameters/dialogs/form-template-category/form-template-category-dialog.tpl.html": 95268,
	"parameters/dialogs/procedure-form/procedure-form-dialog.tpl.html": 11566,
	"parameters/dialogs/visit-forms-submodule/visit-forms-submodule-dialog.tpl.html": 20629,
	"parameters/views/accounts-service-table.tpl.html": 74338,
	"parameters/views/accounts-setup.html": 3621,
	"parameters/views/accounts-table.tpl.html": 11731,
	"parameters/views/adv-observation-form.tpl.html": 50540,
	"parameters/views/adv-observation-indications.tpl.html": 50049,
	"parameters/views/adv-observation-medical-file.tpl.html": 56569,
	"parameters/views/adv-observation-types.tpl.html": 81171,
	"parameters/views/affiliation-edit-tpl.html": 21954,
	"parameters/views/agenda-config-list.html": 85725,
	"parameters/views/agenda-config.html": 94954,
	"parameters/views/agenda-events-config.html": 31457,
	"parameters/views/agenda-general-config.html": 99538,
	"parameters/views/agenda-physician-color-config.html": 93611,
	"parameters/views/agenda-reason-color-config.html": 65603,
	"parameters/views/agenda-room-config.html": 38180,
	"parameters/views/biology-details-not-unique-header.tpl.html": 30756,
	"parameters/views/biology-details-not-unique.tpl.html": 81326,
	"parameters/views/biology-details-unique.tpl.html": 78626,
	"parameters/views/biology-models-table.tpl.html": 3445,
	"parameters/views/biology-models.tpl.html": 11964,
	"parameters/views/biology-parameter-dialog.tpl.html": 22046,
	"parameters/views/biology-parameters-table.tpl.html": 95383,
	"parameters/views/biology-parameters.tpl.html": 72329,
	"parameters/views/biology-setup.html": 31582,
	"parameters/views/block-setup-form.html": 65892,
	"parameters/views/block-setup.html": 14228,
	"parameters/views/bulk-import-patient.html": 24520,
	"parameters/views/care-sheet-printing-form.html": 72483,
	"parameters/views/care-sheet-printing-main.html": 78005,
	"parameters/views/certificate-category-setup.html": 5730,
	"parameters/views/choice-list-setup.html": 76336,
	"parameters/views/cloud-platform-dialog.tpl.html": 90142,
	"parameters/views/cloud-platforms.html": 74675,
	"parameters/views/consent-models-setup.html": 78746,
	"parameters/views/consultation-setup-form.html": 73898,
	"parameters/views/consultation-setup.html": 15027,
	"parameters/views/contact-setup.html": 68657,
	"parameters/views/convention-exceptions.html": 60826,
	"parameters/views/current-patient-fields.tpl.html": 45086,
	"parameters/views/current-patient-setup.html": 36468,
	"parameters/views/dental-setup-general.tpl.html": 46230,
	"parameters/views/dental-setup-procedure-groups.tpl.html": 91503,
	"parameters/views/dental-setup-procedures.tpl.html": 4873,
	"parameters/views/dental-setup.html": 12339,
	"parameters/views/device-drivers.html": 74258,
	"parameters/views/devices-config.html": 41276,
	"parameters/views/dictionary-setup.html": 33114,
	"parameters/views/email-models-setup.html": 57725,
	"parameters/views/email-sms-setup.html": 35819,
	"parameters/views/email-sms-user-setup.html": 93058,
	"parameters/views/establishment.html": 29031,
	"parameters/views/exam-form-setup.html": 11122,
	"parameters/views/exam-list-setup.html": 23379,
	"parameters/views/exam-models-setup.html": 965,
	"parameters/views/exam-setup.html": 78942,
	"parameters/views/exam-template-dialog.tpl.html": 67392,
	"parameters/views/external-patient-api-fields.tpl.html": 74572,
	"parameters/views/external-patient-api-menu.tpl.html": 40677,
	"parameters/views/external-patient-api.html": 36280,
	"parameters/views/form-templates-container.html": 95106,
	"parameters/views/general-app-config.html": 52390,
	"parameters/views/general-billing-config.html": 9784,
	"parameters/views/general-config.html": 46660,
	"parameters/views/general-main-toolbar-config.html": 36521,
	"parameters/views/general-prescription-config.html": 86578,
	"parameters/views/general-stock-config.html": 55475,
	"parameters/views/general-system-config.html": 69172,
	"parameters/views/general-visit-config.html": 22284,
	"parameters/views/general-workflow-config.html": 46444,
	"parameters/views/hospitalization-setup-beds.tpl.html": 78377,
	"parameters/views/hospitalization-setup-floors.tpl.html": 80699,
	"parameters/views/hospitalization-setup-intervention-reason.tpl.html": 65684,
	"parameters/views/hospitalization-setup-procedures.tpl.html": 79219,
	"parameters/views/hospitalization-setup-reason.tpl.html": 2376,
	"parameters/views/hospitalization-setup-rooms.tpl.html": 32976,
	"parameters/views/hospitalization-setup.html": 10105,
	"parameters/views/html-field-dialog.tpl.html": 74471,
	"parameters/views/list-setup-container.html": 19583,
	"parameters/views/location-setup-city.tpl.html": 96941,
	"parameters/views/location-setup-country.tpl.html": 2990,
	"parameters/views/location-setup-province.tpl.html": 73233,
	"parameters/views/location-setup.html": 50716,
	"parameters/views/main.html": 31540,
	"parameters/views/measures-dialog.tpl.html": 53137,
	"parameters/views/measures-setup.html": 32787,
	"parameters/views/medical-care-general.html": 85743,
	"parameters/views/medical-care-procedure-groups.html": 44424,
	"parameters/views/medical-care-procedures.html": 8623,
	"parameters/views/medical-care-protocols.html": 75328,
	"parameters/views/medical-care-setup.html": 98274,
	"parameters/views/medicine-setup-list.html": 96829,
	"parameters/views/medicine-setup.html": 4906,
	"parameters/views/mobile-app-access.tpl.html": 43980,
	"parameters/views/mobile-app-consultation.tpl.html": 86745,
	"parameters/views/mobile-app-patient.tpl.html": 17881,
	"parameters/views/mobile-app-setup.html": 1746,
	"parameters/views/mobile-patient-tablet.tpl.html": 49398,
	"parameters/views/mobile-tablet-background.tpl.html": 73056,
	"parameters/views/observation-setup.html": 50945,
	"parameters/views/operator-edit-tpl.html": 32935,
	"parameters/views/organization.html": 58181,
	"parameters/views/oximetry-config.html": 99409,
	"parameters/views/oxymetry-config-chart-colors.html": 22915,
	"parameters/views/oxymetry-config-general.html": 81227,
	"parameters/views/oxymetry-config-protocols.html": 3297,
	"parameters/views/oxymetry-config-reasons.html": 27501,
	"parameters/views/patient-file-custom-fields.tpl.html": 92886,
	"parameters/views/patient-file-general.tpl.html": 50293,
	"parameters/views/patient-file-required-fields.tpl.html": 41962,
	"parameters/views/patient-file-setup.html": 53116,
	"parameters/views/patient-file-table-columns.tpl.html": 57373,
	"parameters/views/patient-fusion.html": 46199,
	"parameters/views/patient-tablet-dialog.tpl.html": 4320,
	"parameters/views/physician-contact-table.tpl.html": 4645,
	"parameters/views/pregnancy-calendar-configs.html": 45774,
	"parameters/views/pregnancy-calendar-setup.html": 3131,
	"parameters/views/pregnancy-general-config.html": 34838,
	"parameters/views/printing-defaults-form.html": 3050,
	"parameters/views/printing-image-dialog.tpl.html": 55615,
	"parameters/views/printing-images-form.html": 508,
	"parameters/views/printing-template-form.html": 20478,
	"parameters/views/printing.html": 73277,
	"parameters/views/prisma-devices-list.tpl.html": 42078,
	"parameters/views/prisma-order-dialog.tpl.html": 45063,
	"parameters/views/prisma-report-loading-dialog.tpl.html": 16257,
	"parameters/views/procedure-setup.html": 36183,
	"parameters/views/procedures-catalog-container.html": 37918,
	"parameters/views/profile-setup-form.html": 98801,
	"parameters/views/profile-setup.html": 8437,
	"parameters/views/referring-contact-table.tpl.html": 44451,
	"parameters/views/sequence.html": 17121,
	"parameters/views/sequence.tpl.html": 16751,
	"parameters/views/sms-history.html": 6593,
	"parameters/views/sms-models-setup.html": 84675,
	"parameters/views/sms-setup.html": 95773,
	"parameters/views/smtp-setup.html": 43271,
	"parameters/views/specialities-config.html": 96534,
	"parameters/views/speciality-form.tpl.html": 6297,
	"parameters/views/stock-config-table.tpl.html": 75324,
	"parameters/views/summary-file-setup.tpl.html": 56903,
	"parameters/views/survey-setup-form-meanings.tpl.html": 312,
	"parameters/views/survey-setup-form-questions.tpl.html": 11781,
	"parameters/views/survey-setup-form.html": 83797,
	"parameters/views/survey-setup.html": 37177,
	"parameters/views/tablet-survey.html": 473,
	"parameters/views/technician-setup.html": 92774,
	"parameters/views/vaccination-calendar-configs.html": 6294,
	"parameters/views/vaccination-calendar-general.html": 42136,
	"parameters/views/vaccination-calendar-setup.html": 82617,
	"parameters/views/vaccination-calendar-vaccines.html": 13629,
	"patient/measure-blocks/boolean-field.tpl.html": 50958,
	"patient/measure-blocks/calculated-field.tpl.html": 43605,
	"patient/measure-blocks/date-field.tpl.html": 34734,
	"patient/measure-blocks/float-field.tpl.html": 63493,
	"patient/measure-blocks/integer-field.tpl.html": 78605,
	"patient/measure-blocks/string-field.tpl.html": 62224,
	"patient/views/bulk-impot-dialog.tpl.html": 17455,
	"patient/views/coordinate.html": 78197,
	"patient/views/ext-api-search-dialog.tpl.html": 3254,
	"patient/views/insurance-list.html": 66982,
	"patient/views/insurance.html": 65443,
	"patient/views/main.html": 93865,
	"patient/views/measurement-chart-dialog.tpl.html": 74799,
	"patient/views/measurement-form-dialog.tpl.html": 6157,
	"patient/views/measurement-history-dialog.tpl.html": 63314,
	"patient/views/measurement.tpl.html": 27804,
	"patient/views/medical-file.tpl.html": 94497,
	"patient/views/multi-patient-search-dialog.tpl.html": 85028,
	"patient/views/patient-alerts-dialog.tpl.html": 46881,
	"patient/views/patient-category-dialog.tpl.html": 85973,
	"patient/views/patient-form.html": 86930,
	"patient/views/patient-list.html": 50970,
	"patient/views/patient-relations-dialog.tpl.html": 92721,
	"patient/views/patient-search-dialog.tpl.html": 32267,
	"patient/views/summary-field.tpl.html": 75098,
	"patient/views/summary-string-field.tpl.html": 10327,
	"patient/views/summary-url-list.tpl.html": 73581,
	"patient/views/vaccination-dialog.tpl.html": 64455,
	"patient/views/vaccination.tpl.html": 59472,
	"payment/views/account-balance.html": 89146,
	"payment/views/account-details-dialog.tpl.html": 49314,
	"payment/views/account-details.tpl.html": 38275,
	"payment/views/dental-treatment-plans.html": 49584,
	"payment/views/encasement-details.tpl.html": 95033,
	"payment/views/encasement.html": 41803,
	"payment/views/entry-payment.tpl.html": 53627,
	"payment/views/entry-pre-payment.tpl.html": 78634,
	"payment/views/financial-statement-container.html": 21618,
	"payment/views/general-account.html": 82305,
	"payment/views/medical-plan-payment-dialog.tpl.html": 55139,
	"payment/views/medical-plans.html": 61926,
	"payment/views/patient-financial-statement-container.html": 97755,
	"payment/views/payment-form-bottom.html": 37143,
	"payment/views/payment-form-top.html": 45795,
	"payment/views/payment-form.html": 78855,
	"payment/views/payment-list.html": 77256,
	"payment/views/payment-main.html": 70475,
	"payment/views/treatment-plan-payment-dialog.tpl.html": 27741,
	"payment/views/visits.html": 60658,
	"prescription/components/biology-table/biology-table.tpl.html": 59712,
	"prescription/components/legacy-biology-table/legacy-biology-table.tpl.html": 98092,
	"prescription/components/prescription-item/biology-prescription-item.tpl.html": 45648,
	"prescription/components/prescription-item/care-prescription-item.tpl.html": 63258,
	"prescription/components/prescription-item/medical-prescription-item.tpl.html": 42632,
	"prescription/components/prescription-item/prescription-item.tpl.html": 68691,
	"prescription/components/prescription-item/procedure-prescription-item.tpl.html": 55947,
	"prescription/components/prescription-item/text-prescription-item.tpl.html": 43547,
	"prescription/controllers/biology-prescription-form/biology-prescription-form.html": 70625,
	"prescription/controllers/care-prescription-form/care-prescription-form.html": 98247,
	"prescription/controllers/medical-prescription-form/body-container.html": 12201,
	"prescription/controllers/medical-prescription-form/detail-container.html": 95640,
	"prescription/controllers/medical-prescription-form/detail-generator.html": 86334,
	"prescription/controllers/medical-prescription-form/medical-prescription-form.html": 53626,
	"prescription/controllers/prescription-container/prescription-container.html": 67646,
	"prescription/controllers/prescription-list/prescription-list.html": 74811,
	"prescription/controllers/prescription-view/prescription-view.html": 18034,
	"prescription/controllers/procedure-prescription-form/procedure-prescription-form.html": 27448,
	"prescription/controllers/text-prescription-form/text-prescription-form.html": 31513,
	"prescription/dialogs/biology-result-dialog/biology-result-dialog.tpl.html": 33287,
	"prescription/dialogs/biology-resume-dialog/biology-resume-dialog.tpl.html": 38669,
	"prescription/directives/biology-row/details-not-unique-header.tpl.html": 61979,
	"prescription/directives/biology-row/details-not-unique.tpl.html": 21453,
	"prescription/directives/biology-row/details-unique.tpl.html": 26351,
	"rehabilitation/views/current-exams.html": 90828,
	"rehabilitation/views/device-dialog.tpl.html": 44281,
	"rehabilitation/views/devices.tpl.html": 64769,
	"rehabilitation/views/exams-list.html": 24956,
	"rehabilitation/views/rehabilitation.html": 75623,
	"rehabilitation/views/settings.html": 79914,
	"rehabilitation/views/training-block.tpl.html": 84490,
	"shared/views/biology-tree.tpl.html": 32409,
	"shared/views/contact-dialog.tpl.html": 26828,
	"shared/views/contacts-list.html": 63881,
	"shared/views/convention-dialog.tpl.html": 53892,
	"shared/views/convention-search-dialog.tpl.html": 57476,
	"shared/views/custom-contact.tpl.html": 21410,
	"shared/views/email-sharing-dialog.tpl.html": 52966,
	"shared/views/filter-dialog.tpl.html": 37430,
	"shared/views/list.custom-list.tpl.html": 30647,
	"shared/views/list.default.tpl.html": 29072,
	"shared/views/list.dosage-form.tpl.html": 17295,
	"shared/views/list.prescription-frequency.tpl.html": 17784,
	"shared/views/list.sport-team-category.tpl.html": 24332,
	"shared/views/list.title.tpl.html": 51639,
	"shared/views/loader.html": 39987,
	"shared/views/location-dialog.tpl.html": 36632,
	"shared/views/main.html": 7258,
	"shared/views/medicine-dialog.tpl.html": 53210,
	"shared/views/medicine-posologies.tpl.html": 43285,
	"shared/views/medicine-search-dialog.tpl.html": 85443,
	"shared/views/notification-dialog.tpl.html": 48726,
	"shared/views/notification-list-dialog.tpl.html": 98452,
	"shared/views/notification.tpl.html": 37952,
	"shared/views/organization-dialog.tpl.html": 31685,
	"shared/views/print.tpl.html": 3109,
	"shared/views/procedure-dialog.tpl.html": 61391,
	"shared/views/procedure-table.tpl.html": 37720,
	"shared/views/prompt-dialog.tpl.html": 44742,
	"shared/views/report-as-entry-type.tpl.html": 72708,
	"shared/views/side-nav.tpl.html": 66119,
	"shared/views/sms-sending-dialog.tpl.html": 98621,
	"shared/views/style.tpl.html": 36475,
	"shared/views/table-custom-filter.html": 82084,
	"shared/views/table-filter-item.html": 16616,
	"shared/views/table-sidenav.html": 89378,
	"shared/views/table-style-rules.html": 50157,
	"shared/views/table.tpl.html": 91622,
	"shared/views/text-editor-custom.tpl.html": 64653,
	"shared/views/toolbar.tpl.html": 45329,
	"shared/views/vaccine-dialog.tpl.html": 51089,
	"shared/views/voice-recognition-dialog.tpl.html": 66421,
	"shared/views/web-cam-dialog.tpl.html": 1618,
	"specifics/components/custom-classification-field/custom-classification-field.tpl.html": 97437,
	"specifics/components/diagnostics-block/diagnostics-block.tpl.html": 17296,
	"specifics/components/icd-field/icd-field.tpl.html": 63989,
	"specifics/components/osiics-field/osiics-field.tpl.html": 44225,
	"specifics/components/pregnancy-block/pregnancy-block.tpl.html": 61924,
	"specifics/components/pregnancy-term/pregnancy-term.tpl.html": 78979,
	"specifics/components/vaccination-calendar-block/vaccination-calendar-block.tpl.html": 63536,
	"specifics/dialogs/birth-validation-dialog/birth-validation-dialog.tpl.html": 23535,
	"specifics/dialogs/osiics-classification-dialog/osiics-classification.tpl.html": 38674,
	"specifics/dialogs/pregnancy-event-form-dialog/pregnancy-event-form.tpl.html": 86499,
	"specifics/dialogs/pregnancy-milestone-form-dialog/pregnancy-milestone-form.tpl.html": 98228,
	"specifics/dialogs/service-order-scheduling-dialog/service-order-scheduling-dialog.tpl.html": 47403,
	"specifics/dialogs/vaccination-config-container-dialog/vaccination-config-container.tpl.html": 13675,
	"specifics/dialogs/vaccination-config-form-dialog/vaccination-config-form.tpl.html": 75494,
	"specifics/dialogs/vaccination-line-form-dialog/vaccination-line-form.tpl.html": 53919,
	"specifics/dialogs/vaccine-form-dialog/vaccine-form.tpl.html": 96953,
	"specifics/svg/human-skeleton-back.svg": 33064,
	"specifics/svg/human-skeleton-front.svg": 68870,
	"specifics/views/growth-charts.tpl.html": 68828,
	"specifics/views/growth-setup.tpl.html": 47909,
	"specifics/views/gynecology-info.tpl.html": 67879,
	"specifics/views/human-skeleton.tpl.html": 60785,
	"specifics/views/hur-exam.html": 93686,
	"specifics/views/ophthalmic-prescription.tpl.html": 60805,
	"specifics/views/pathologies-form.tpl.html": 79654,
	"specifics/views/pt-block.tpl.html": 38904,
	"specifics/views/traumato-container.html": 63586,
	"stand-alone/blocks/components/custom-fields-block/custom-fields-block.tpl.html": 94579,
	"stand-alone/blocks/components/custom-fields-table/custom-fields-table.tpl.html": 29153,
	"stand-alone/blocks/components/form-html-block/form-html-block.tpl.html": 49685,
	"stand-alone/blocks/components/html-block/form-block.tpl.html": 48217,
	"stand-alone/blocks/components/html-block/html-block.tpl.html": 53997,
	"stand-alone/blocks/components/html-block/survey-block.tpl.html": 19166,
	"stand-alone/blocks/components/survey-question/survey-question.tpl.html": 57736,
	"stand-alone/blocks/components/survey-resume/survey-resume.tpl.html": 98383,
	"stand-alone/blocks/dialogs/dictionary-history-dialog/dictionary-history-dialog.tpl.html": 94603,
	"stand-alone/blocks/views/autocomplete.tpl.html": 19402,
	"stand-alone/blocks/views/choice-list.tpl.html": 50725,
	"stand-alone/blocks/views/dictionary-chip-edition-dialog.tpl.html": 26589,
	"stand-alone/blocks/views/dictionary-models-dialog.tpl.html": 44135,
	"stand-alone/blocks/views/dictionary-multi-node-dialog.tpl.html": 73260,
	"stand-alone/blocks/views/dictionary-new-entry-dialog.tpl.html": 40437,
	"stand-alone/blocks/views/dictionary-tree-view.tpl.html": 19694,
	"stand-alone/blocks/views/dictionary-tree.tpl.html": 51611,
	"stand-alone/blocks/views/dictionary.tpl.html": 75298,
	"stand-alone/blocks/views/file-block.tpl.html": 26421,
	"stand-alone/blocks/views/free-dictionary.tpl.html": 55546,
	"stand-alone/dcm/dialogs/aet/aet-dialog.tpl.html": 36976,
	"stand-alone/dcm/dialogs/dcm-instances/dcm-instances-dialog.tpl.html": 33153,
	"stand-alone/dcm/dialogs/dcm-order/dcm-order-dialog.tpl.html": 26567,
	"stand-alone/dcm/dialogs/dcm-viewer/dcm-viewer-dialog.tpl.html": 16078,
	"stand-alone/dcm/dialogs/fire-pacs-studies/fire-pacs-studies-dialog.tpl.html": 67348,
	"stand-alone/dcm/dialogs/requested-procedure/requested-procedure-dialog.tpl.html": 17047,
	"stand-alone/file-manager/views/audio-record-dialog.tpl.html": 21867,
	"stand-alone/file-manager/views/contextual-files.tpl.html": 84411,
	"stand-alone/file-manager/views/dental-file-upload-dialog.tpl.html": 93762,
	"stand-alone/file-manager/views/excel-viewer.tpl.html": 95459,
	"stand-alone/file-manager/views/file-update-dialog.tpl.html": 97733,
	"stand-alone/file-manager/views/files.html": 66253,
	"stand-alone/file-manager/views/grid-item.html": 31820,
	"stand-alone/file-manager/views/image-editor.tpl.html": 29156,
	"stand-alone/file-manager/views/list-item.html": 36591,
	"stand-alone/file-manager/views/pdf-viewer.tpl.html": 29842,
	"stand-alone/file-manager/views/tag-item.html": 21822,
	"stand-alone/file-manager/views/visualize-file-dialog.tpl.html": 3863,
	"stand-alone/image-edition/views/actions.tpl.html": 11142,
	"stand-alone/image-edition/views/brightness-option.tpl.html": 20966,
	"stand-alone/image-edition/views/contrast-option.tpl.html": 20668,
	"stand-alone/image-edition/views/crop-option.html": 766,
	"stand-alone/image-edition/views/drawing-option.tpl.html": 66849,
	"stand-alone/image-edition/views/form-option.tpl.html": 32041,
	"stand-alone/image-edition/views/image-edition.tpl.html": 9982,
	"stand-alone/image-edition/views/options.tpl.html": 67077,
	"stand-alone/image-edition/views/police-option.tpl.html": 82327,
	"stand-alone/interfacing/views/date-time-field.tpl.html": 12465,
	"stand-alone/interfacing/views/import-exam-dialog.tpl.html": 7670,
	"stand-alone/interfacing/views/order-form-dialog.tpl.html": 210,
	"stand-alone/patient-summary/views/certificates-list.tpl.html": 7082,
	"stand-alone/patient-summary/views/consultation.tpl.html": 70369,
	"stand-alone/patient-summary/views/consultations-list.tpl.html": 12234,
	"stand-alone/patient-summary/views/exams-list.tpl.html": 70927,
	"stand-alone/patient-summary/views/filters-dialog.tpl.html": 84326,
	"stand-alone/patient-summary/views/main.tpl.html": 98219,
	"stand-alone/patient-summary/views/prescriptions-list.tpl.html": 23595,
	"stand-alone/patient-summary/views/summary-dialog.tpl.html": 85962,
	"stand-alone/patient-summary/views/visit.tpl.html": 67669,
	"stand-alone/sport-data/components/sport-file-details/sport-file-details.tpl.html": 16252,
	"stand-alone/sport-data/components/sport-file/sport-file.tpl.html": 35519,
	"stand-alone/sport-data/controllers/sport-data-setup/sport-data-general.html": 90279,
	"stand-alone/sport-data/controllers/sport-data-setup/sport-data-organizations.html": 40580,
	"stand-alone/sport-data/controllers/sport-data-setup/sport-data-setup.html": 9284,
	"stand-alone/sport-data/dialogs/sport-organization/sport-organization-dialog.tpl.html": 99467,
	"stand-alone/table/views/table-column-menu.html": 82258,
	"stand-alone/table/views/table-date-search.html": 5095,
	"stand-alone/table/views/table-main.html": 35825,
	"stand-alone/table/views/table-select-search.html": 56821,
	"stand-alone/table/views/table-text-search.html": 73675,
	"stand-alone/technical-file/components/technical-file/technical-file.tpl.html": 11516,
	"stand-alone/technical-file/controllers/technical-file-setup/technical-file-fields.html": 81012,
	"stand-alone/technical-file/controllers/technical-file-setup/technical-file-general.html": 63598,
	"stand-alone/technical-file/controllers/technical-file-setup/technical-file-lists.html": 53290,
	"stand-alone/technical-file/controllers/technical-file-setup/technical-file-setup.html": 14154,
	"stand-alone/technical-file/dialogs/advanced-filter/advenced-filter-dialog.tpl.html": 18960,
	"stand-alone/text-editor/components/sms-editor/sms-editor.tpl.html": 94464,
	"stand-alone/text-editor/dialogs/custom-var/custom-var-form.tpl.html": 59559,
	"stand-alone/text-editor/dialogs/custom-var/custom-var.tpl.html": 10750,
	"stand-alone/text-editor/dialogs/editor-contextual-template-form/editor-contextual-template-form.tpl.html": 34780,
	"stand-alone/text-editor/dialogs/editor-contextual-templates/editor-contextual-templates.tpl.html": 96115,
	"stand-alone/text-editor/dialogs/fill-custom-var/fill-custom-var.tpl.html": 5125,
	"stand-alone/video-call/dialogs/video-call/video-call.dialog.html": 86076,
	"stock/views/article-complementary-code.html": 39585,
	"stock/views/article-components.html": 21554,
	"stock/views/article-form-dialog.tpl.html": 92298,
	"stock/views/article-form.html": 3346,
	"stock/views/article-historic.tpl.html": 99028,
	"stock/views/article-list.html": 9085,
	"stock/views/article-main.html": 5990,
	"stock/views/article-medicine-form.html": 42022,
	"stock/views/article-medicine-main.html": 23718,
	"stock/views/article-search-modal.tpl.html": 41525,
	"stock/views/article-substitution.html": 32673,
	"stock/views/articles-shortages-historic.html": 73783,
	"stock/views/bar-code-scan.tpl.html": 37232,
	"stock/views/business-detail-dialog.tpl.html": 74257,
	"stock/views/business-detail-list.html": 69164,
	"stock/views/charge-dialog.tpl.html": 80955,
	"stock/views/comment-dialog.tpl.html": 32241,
	"stock/views/comment-preview.tpl.html": 42790,
	"stock/views/consigned-lots-return-dialog.tpl.html": 33774,
	"stock/views/consignment-form.html": 15853,
	"stock/views/consignment-return-form.html": 72835,
	"stock/views/credit-note-form.html": 57845,
	"stock/views/customer-order-form.html": 88062,
	"stock/views/delivery-form.html": 19249,
	"stock/views/delivery-return-form.html": 62315,
	"stock/views/deposition-form.html": 8076,
	"stock/views/deposition-lots-dialog.tpl.html": 89314,
	"stock/views/document-comment.tpl.html": 67917,
	"stock/views/document-lines-header.tpl.html": 54254,
	"stock/views/document-search-modal.tpl.html": 9203,
	"stock/views/expired-articles-historic.html": 9915,
	"stock/views/family-dialog.tpl.html": 6981,
	"stock/views/family-list.html": 33659,
	"stock/views/generate-delivery-form-dialog.tpl.html": 34800,
	"stock/views/generate-stock-doc-dialog.tpl.html": 65442,
	"stock/views/in-lots-dialog.tpl.html": 63527,
	"stock/views/in-serials-dialog.tpl.html": 78879,
	"stock/views/inventory-form.html": 64734,
	"stock/views/inventory-lines.tpl.html": 11900,
	"stock/views/inventory-lots-dialog.tpl.html": 55359,
	"stock/views/inventory-serials-dialog.tpl.html": 80544,
	"stock/views/invoice-form.html": 95721,
	"stock/views/lots-dialog.tpl.html": 16608,
	"stock/views/merge-documents-dialog.tpl.html": 29750,
	"stock/views/movement-form.html": 16988,
	"stock/views/movement-state.html": 51538,
	"stock/views/movements-by-business-state.html": 44855,
	"stock/views/opening-balance-form.html": 82226,
	"stock/views/order-form.html": 38734,
	"stock/views/out-lots-dialog.tpl.html": 6024,
	"stock/views/out-serials-dialog.tpl.html": 98698,
	"stock/views/patient-movement-state.html": 6132,
	"stock/views/price-request-form.html": 21321,
	"stock/views/price-request-response.tpl.html": 46543,
	"stock/views/provider-dialog.tpl.html": 8150,
	"stock/views/provider-list.html": 81837,
	"stock/views/provider-search-modal.tpl.html": 35241,
	"stock/views/purchase-request.html": 75689,
	"stock/views/recalculate-article-stock.html": 86773,
	"stock/views/receipt-form.html": 22328,
	"stock/views/return-form.html": 89349,
	"stock/views/serials-dialog.tpl.html": 76101,
	"stock/views/serials-lots-state.html": 10488,
	"stock/views/stock-doc-actions.tpl.html": 99710,
	"stock/views/stock-document-details.tpl.html": 7651,
	"stock/views/stock-document-lines.tpl.html": 64781,
	"stock/views/stock-document-list.html": 21539,
	"stock/views/stock.html": 47212,
	"stock/views/tariff-details-dialog.tpl.html": 5715,
	"stock/views/tariff-details.tpl.html": 33629,
	"stock/views/tariff.html": 51455,
	"stock/views/transformation-form.html": 18239,
	"stock/views/warehouse-dialog.tpl.html": 10712,
	"stock/views/warehouse-exchange-form.html": 94230,
	"stock/views/warehouse-exchange-historic.html": 20914,
	"stock/views/warehouse-list.html": 92376,
	"visit/views/errors-visit-dialog.tpl.html": 20445,
	"visit/views/payable-payments.tpl.html": 87727,
	"visit/views/visit-financial.tpl.html": 72089,
	"visit/views/visit-list.html": 70285,
	"visit/views/visit-procedures.tpl.html": 1384,
	"visit/views/visit.main.html": 33095,
	"workflow/components/workflow-filter/workflow-filter.html": 50143,
	"workflow/controllers/daily-workflow/daily-workflow.html": 6194,
	"workflow/controllers/service-order/service-order-workflow.html": 14297,
	"workflow/controllers/workflow-container/workflow-container.html": 61897,
	"workflow/dialogs/service-order-preview/service-order-preview.tpl.html": 45016
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22818;